module.exports = __webpack_public_path__ + "img/one_account.12054989.png";